import $http from '@/libs/axios'

export default class WebViewApi {
  static async deleteTemplate(id: string) {
    return (await $http.delete(`webview/templates/destroy/${id}`)).data
  }

  static async deleteRequest(id: string) {
    return (await $http.delete(`webview/requests/destroy/${id}`)).data
  }

  static async findRequest(requestId: any) {
    return (await $http.get(`webview/requests/get/${requestId}`)).data
  }

  static async findTemplate(templateId: any) {
    return (await $http.get(`webview/templates/get/${templateId}`)).data
  }

  static async templatesList(pageId: number) {
    return (await $http.get(`webview/templates/list/${pageId}`)).data
  }

  static async requestsList(pageId: number) {
    return (await $http.get(`webview/requests/list/${pageId}`)).data
  }

  static async addTemplate(data: any) {
    return (await $http.post('webview/templates/create', data)).data
  }

  static async updateTemplate(id: any, data: any) {
    return (await $http.post(`webview/templates/update/${id}`, data)).data
  }

  static async updateRequest(id: any, data: any) {
    return (await $http.post(`webview/requests/update/${id}`, data)).data
  }
}
